import React, { FC } from 'react'

type BannerAppComponentProps = {
    title: string,
    description: string,
    bgImage: string
}

const BannerAppComponent: FC<BannerAppComponentProps> = ({ title, description, bgImage }) => {
    return (
        <div className={`${bgImage} bg-center  bg-cover bg-no-repeat`}>
            <div className='bg-blackTransparent'>
                <div className='flex flex-col md:flex-row px-4 sm:px-6 md:px-[9%] pt-48 md:pt-52 pb-4 h-[550px] md:h-auto'>
                    <div className='text-white flex flex-col gap-2 h-auto md:h-[700px] relative w-full md:w-[65%] xl:w-[50%]'>
                        <div className='capitalize font-bold text-3xl sm:text-5xl md:text-7xl leading-tight md:leading-snug'>{title}</div>
                        <div className='font-medium text-lg sm:text-xl md:text-2xl mb-8 md:mb-0'>{description}</div>
                    </div>
                    <div className='relative'>
                        {/* Empty div for potential image/content */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BannerAppComponent
